import { calculateUniformDistribution } from './calculateUniformDistribution';
import type { ICalculateWorkloadDistributionProps } from './ICalculateWorkloadDistributionProps';

// TODO: implement normal distribution
export function calculateNormalDistribution(props: ICalculateWorkloadDistributionProps) {
  return calculateUniformDistribution(props);
}
